export const OAUTH_TIPO_OPTIONS = [
  {
    value: 'shortcut',
    title: 'Somente atalho',
    subtitle: 'Link na Home do Configurador',
    description:
      'Sem login OAuth. O atalho na Home só aparece para usuários com acesso liberado no cadastro.',
    icon: 'fas fa-external-link-alt',
    redirectExample: '',
  },
  {
    value: 'hybrid',
    title: 'Híbrida (frontend + backend)',
    subtitle: 'SPA no navegador e API/servidor no mesmo app',
    description:
      'Gera Client Secret para o backend e também aceita login via PKCE no browser, com o mesmo App ID.',
    icon: 'fas fa-project-diagram',
    redirectExample: 'https://meu-app.exemplo.com/auth/callback\nhttp://localhost:5173/callback\nhttps://api.meu-servico.exemplo.com/oauth/callback',
  },
  {
    value: 'public',
    title: 'Pública (somente frontend)',
    subtitle: 'React, Vue, Angular ou app no navegador',
    description:
      'O login usa PKCE e não exige Client Secret. Use quando só o código no browser troca o token.',
    icon: 'fas fa-window-maximize',
    redirectExample: 'https://meu-app.exemplo.com/auth/callback\nhttp://localhost:5173/callback',
  },
  {
    value: 'confidential',
    title: 'Confidencial (somente backend)',
    subtitle: 'API, serviço ou servidor com credenciais',
    description:
      'Gera Client Secret na criação. A troca do código por token deve acontecer em um servidor seguro.',
    icon: 'fas fa-server',
    redirectExample: 'https://api.meu-servico.exemplo.com/oauth/callback',
  },
];

export function isShortcutOnlyType(tipo) {
  return tipo === 'shortcut';
}

export function isOAuthIntegrationType(tipo) {
  return Boolean(tipo) && tipo !== 'shortcut';
}

export function getOAuthTipoLabel(tipo) {
  return OAUTH_TIPO_OPTIONS.find((item) => item.value === tipo)?.title || tipo || '—';
}

export const OAUTH_STANDARD_SCOPES = [
  {
    value: 'openid',
    label: 'openid',
    description: 'Identificação OIDC do usuário (sempre incluído)',
    required: true,
  },
  {
    value: 'profile',
    label: 'profile',
    description: 'Nome e dados básicos do perfil',
  },
  {
    value: 'permissions',
    label: 'permissions',
    description: 'Papéis do usuário neste app (incluído quando há App Roles)',
  },
];

export const APP_ROLE_KEY_REGEX = /^[a-z][a-z0-9_]{1,48}$/;

export const OAUTH_APP_ICON_OPTIONS = [
  // IA e comunicação
  { value: 'fas fa-robot', label: 'Robô / Chatbot' },
  { value: 'fas fa-comments', label: 'Chat' },
  { value: 'fas fa-brain', label: 'IA' },
  { value: 'fas fa-microphone', label: 'Áudio / Podcast' },
  { value: 'fas fa-video', label: 'Vídeo' },
  { value: 'fas fa-envelope', label: 'E-mail' },
  { value: 'fas fa-bell', label: 'Notificações' },
  { value: 'fas fa-bullhorn', label: 'Marketing' },
  // Dados e analytics
  { value: 'fas fa-chart-line', label: 'Analytics' },
  { value: 'fas fa-chart-bar', label: 'Relatórios' },
  { value: 'fas fa-chart-pie', label: 'Dashboard' },
  { value: 'fas fa-database', label: 'Dados' },
  { value: 'fas fa-search', label: 'Busca' },
  { value: 'fas fa-filter', label: 'Filtros' },
  // Comercial e financeiro
  { value: 'fas fa-shopping-cart', label: 'Comercial' },
  { value: 'fas fa-store', label: 'Loja' },
  { value: 'fas fa-tags', label: 'Produtos' },
  { value: 'fas fa-credit-card', label: 'Pagamentos' },
  { value: 'fas fa-wallet', label: 'Carteira' },
  { value: 'fas fa-coins', label: 'Financeiro' },
  { value: 'fas fa-handshake', label: 'Parcerias' },
  { value: 'fas fa-receipt', label: 'Faturamento' },
  // Pessoas e suporte
  { value: 'fas fa-headset', label: 'Suporte' },
  { value: 'fas fa-users', label: 'Equipe' },
  { value: 'fas fa-user-tie', label: 'Gestão' },
  { value: 'fas fa-user-shield', label: 'Administração' },
  { value: 'fas fa-id-card', label: 'Cadastro' },
  { value: 'fas fa-address-book', label: 'Contatos' },
  { value: 'fas fa-ticket-alt', label: 'Tickets' },
  // Tecnologia
  { value: 'fas fa-plug', label: 'Integração' },
  { value: 'fas fa-code', label: 'Desenvolvimento' },
  { value: 'fas fa-cloud', label: 'Cloud' },
  { value: 'fas fa-server', label: 'Servidor' },
  { value: 'fas fa-microchip', label: 'Hardware' },
  { value: 'fas fa-puzzle-piece', label: 'Módulo' },
  { value: 'fas fa-sitemap', label: 'Fluxos' },
  { value: 'fas fa-project-diagram', label: 'Processos' },
  // Dispositivos e web
  { value: 'fas fa-mobile-alt', label: 'App mobile' },
  { value: 'fas fa-tablet-alt', label: 'Tablet' },
  { value: 'fas fa-laptop', label: 'Notebook' },
  { value: 'fas fa-desktop', label: 'Desktop' },
  { value: 'fas fa-globe', label: 'Web' },
  { value: 'fas fa-qrcode', label: 'QR Code' },
  // Segurança
  { value: 'fas fa-key', label: 'Segurança' },
  { value: 'fas fa-lock', label: 'Acesso restrito' },
  { value: 'fas fa-shield-alt', label: 'Proteção' },
  { value: 'fas fa-fingerprint', label: 'Autenticação' },
  // Operações
  { value: 'fas fa-cogs', label: 'Ferramentas' },
  { value: 'fas fa-tools', label: 'Manutenção' },
  { value: 'fas fa-clipboard-list', label: 'Checklist' },
  { value: 'fas fa-tasks', label: 'Tarefas' },
  { value: 'fas fa-calendar-alt', label: 'Agenda' },
  { value: 'fas fa-file-alt', label: 'Documentos' },
  { value: 'fas fa-print', label: 'Impressão' },
  { value: 'fas fa-sync', label: 'Sincronização' },
  // Logística
  { value: 'fas fa-truck', label: 'Entregas' },
  { value: 'fas fa-box', label: 'Estoque' },
  { value: 'fas fa-warehouse', label: 'Armazém' },
  { value: 'fas fa-map-marker-alt', label: 'Localização' },
  // Negócios
  { value: 'fas fa-building', label: 'Empresa' },
  { value: 'fas fa-briefcase', label: 'Corporativo' },
  { value: 'fas fa-industry', label: 'Indústria' },
  { value: 'fas fa-rocket', label: 'Lançamento' },
  { value: 'fas fa-lightbulb', label: 'Inovação' },
  { value: 'fas fa-star', label: 'Destaque' },
  // Saúde e educação
  { value: 'fas fa-heartbeat', label: 'Saúde' },
  { value: 'fas fa-stethoscope', label: 'Clínica' },
  { value: 'fas fa-graduation-cap', label: 'Educação' },
  { value: 'fas fa-book', label: 'Conteúdo' },
  // Outros
  { value: 'fas fa-palette', label: 'Design' },
  { value: 'fas fa-camera', label: 'Fotos' },
  { value: 'fas fa-gamepad', label: 'Games' },
  { value: 'fas fa-car', label: 'Mobilidade' },
  { value: 'fas fa-plane', label: 'Viagens' },
  { value: 'fas fa-leaf', label: 'Sustentabilidade' },
  { value: 'fas fa-gift', label: 'Promoções' },
  { value: 'fas fa-th-large', label: 'Portal' },
];

export function createEmptyAppRole() {
  return { codigo: '', descricao: '' };
}

export function parseAppRoleToForm(entry) {
  if (typeof entry === 'string') {
    return { codigo: entry, descricao: '' };
  }

  return {
    codigo: entry?.codigo || '',
    descricao: entry?.descricao || '',
  };
}

export function getAppRoleCodigo(role) {
  if (typeof role === 'string') {
    return role;
  }

  return role?.codigo || '';
}

export function getAppRoleDescricao(role) {
  if (typeof role === 'string') {
    return formatAppRoleLabel(role);
  }

  const descricao = String(role?.descricao || '').trim();
  if (descricao) {
    return descricao;
  }

  return formatAppRoleLabel(role?.codigo);
}

export function normalizeAppRolesForPayload(appRoles) {
  const seen = new Set();
  const result = [];

  for (const entry of appRoles || []) {
    const codigo = normalizeAppRoleKey(getAppRoleCodigo(entry));
    if (!isValidAppRoleKey(codigo) || seen.has(codigo)) {
      continue;
    }

    seen.add(codigo);
    result.push({
      codigo,
      descricao: String(typeof entry === 'object' ? entry.descricao : '')
        .trim()
        .slice(0, 120),
    });
  }

  return result;
}

export function formatAppRolesList(appRoles) {
  return normalizeAppRolesForPayload(appRoles)
    .map((role) => role.codigo)
    .join(', ');
}

export const OAUTH_SHORTCUT_GRADIENTS = [
  'linear-gradient(135deg, #5e5ce6, #007aff)',
  'linear-gradient(135deg, #34c759, #30d158)',
  'linear-gradient(135deg, #ff9500, #ffcc00)',
  'linear-gradient(135deg, #bf5af2, #af52de)',
  'linear-gradient(135deg, #32ade6, #007aff)',
  'linear-gradient(135deg, #ff2d55, #ff6482)',
];

export function normalizeAppRoleKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, '_')
    .replace(/^[^a-z]+/, '');
}

export function isValidAppRoleKey(value) {
  return APP_ROLE_KEY_REGEX.test(normalizeAppRoleKey(value));
}

export function formatAppRoleLabel(role) {
  return String(role || '')
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

const OAUTH_SCOPE_CONSENT_COPY = {
  openid: {
    title: 'Identificação',
    description: 'ID único da sua conta no Configurador.',
  },
  profile: {
    title: 'Perfil',
    description: 'Nome e login do seu cadastro.',
  },
  permissions: {
    title: 'Papéis',
    description: 'Perfis internos que você possui neste app.',
  },
};

export function formatOAuthAutoresLabel(autores) {
  const names = (autores || [])
    .map((autor) => String(autor?.nome || autor?.usuario || '').trim())
    .filter(Boolean);

  if (!names.length) {
    return '';
  }

  if (names.length === 1) {
    return `Criado por ${names[0]}`;
  }

  if (names.length === 2) {
    return `Criado por ${names[0]} e ${names[1]}`;
  }

  const last = names[names.length - 1];
  const rest = names.slice(0, -1).join(', ');
  return `Criado por ${rest} e ${last}`;
}

export function describeOAuthScopeForConsent(scope, client = {}) {
  const standard = OAUTH_STANDARD_SCOPES.find((item) => item.value === scope);
  if (standard) {
    const copy = OAUTH_SCOPE_CONSENT_COPY[scope];
    return {
      key: scope,
      label: copy?.title || standard.label,
      description: copy?.description || standard.description,
      technical: scope,
    };
  }

  const clientId = client.clientId || client.id || '';
  const prefix = `${clientId}:`;
  if (clientId && scope.startsWith(prefix)) {
    const codigo = scope.slice(prefix.length);
    const role = (client.appRoles || []).find((entry) => getAppRoleCodigo(entry) === codigo);

    return {
      key: scope,
      label: role ? getAppRoleDescricao(role) : formatAppRoleLabel(codigo),
      description: 'Perfil interno concedido a você nesta aplicação.',
      technical: codigo,
    };
  }

  return {
    key: scope,
    label: scope,
    description: 'Permissão solicitada pela aplicação.',
    technical: scope,
  };
}

export function describeUserRoleForConsent(role, client = {}) {
  const match = (client.appRoles || []).find((entry) => getAppRoleCodigo(entry) === role);

  return {
    codigo: role,
    label: match ? getAppRoleDescricao(match) : formatAppRoleLabel(role),
  };
}

export function createEmptyOAuthAppForm() {
  return {
    id: '',
    nome: '',
    descricao: '',
    tipo: '',
    ativo: true,
    standardScopes: ['openid', 'profile', 'permissions'],
    appRoles: [],
    autores: [],
    icone: 'fas fa-plug',
    exibirAtalho: false,
    linkLogin: '',
    redirectUrisText: '',
  };
}

export function clientToForm(client) {
  const standardValues = OAUTH_STANDARD_SCOPES.map((item) => item.value);
  const scopeList = Array.isArray(client.scopes) ? client.scopes : [];
  const standardScopes = scopeList.filter((scope) => standardValues.includes(scope));

  if (!standardScopes.includes('openid')) {
    standardScopes.unshift('openid');
  }

  const appRoles = Array.isArray(client.appRoles) && client.appRoles.length
    ? client.appRoles.map(parseAppRoleToForm)
    : parseLegacyAppRolesFromScopes(client.clientId || client.id, scopeList)
      .map((codigo) => ({ codigo, descricao: '' }));

  return {
    id: client.id,
    nome: client.nome || '',
    descricao: client.descricao || '',
    tipo: client.tipo || 'hybrid',
    ativo: client.ativo !== false,
    standardScopes,
    appRoles,
    autores: Array.isArray(client.autores) ? [...client.autores] : [],
    icone: client.icone || 'fas fa-plug',
    exibirAtalho: client.exibirAtalho === true,
    linkLogin: client.linkLogin || '',
    redirectUrisText: (client.redirectUris || []).join('\n'),
  };
}

function parseLegacyAppRolesFromScopes(clientId, scopes) {
  if (!clientId) {
    return [];
  }

  const prefix = `${clientId}:`;
  return (scopes || [])
    .filter((scope) => scope.startsWith(prefix))
    .map((scope) => scope.slice(prefix.length))
    .filter(Boolean);
}

export function buildScopesPreview(appId, standardScopes, appRoles) {
  const scopes = [...new Set(standardScopes || [])];

  if (!scopes.includes('openid')) {
    scopes.unshift('openid');
  }

  const normalizedAppId = (appId || '').trim();
  (appRoles || []).forEach((role) => {
    const codigo = getAppRoleCodigo(role);
    if (codigo) {
      scopes.push(`${normalizedAppId}:${codigo}`);
    }
  });

  return [...new Set(scopes)];
}

export function parseRedirectUris(text) {
  return (text || '')
    .split('\n')
    .map((uri) => uri.trim())
    .filter(Boolean);
}

export function buildOAuthAppPayload(form) {
  if (isShortcutOnlyType(form.tipo)) {
    return {
      id: form.id || undefined,
      nome: form.nome.trim(),
      descricao: form.descricao.trim(),
      tipo: 'shortcut',
      ativo: form.ativo,
      redirectUris: [],
      standardScopes: [],
      appRoles: [],
      autores: [],
      icone: form.icone || 'fas fa-plug',
      exibirAtalho: true,
      linkLogin: (form.linkLogin || '').trim(),
    };
  }

  const appRoles = normalizeAppRolesForPayload(form.appRoles);

  return {
    id: form.id || undefined,
    nome: form.nome.trim(),
    descricao: form.descricao.trim(),
    tipo: form.tipo,
    ativo: form.ativo,
    redirectUris: parseRedirectUris(form.redirectUrisText),
    standardScopes: form.standardScopes,
    appRoles,
    autores: Array.isArray(form.autores) ? form.autores : [],
    icone: form.icone || 'fas fa-plug',
    exibirAtalho: form.exibirAtalho === true,
    linkLogin: (form.linkLogin || '').trim(),
  };
}

export const CONFIGURADOR_OAUTH_LAUNCH_PARAM = 'configurador_oauth';
export const CONFIGURADOR_OAUTH_LAUNCH_VALUE = '1';

export function appendConfiguradorOAuthLaunchParam(url) {
  try {
    const parsed = new URL(url);

    if (/callback/i.test(parsed.pathname)) {
      return url;
    }

    parsed.searchParams.set(CONFIGURADOR_OAUTH_LAUNCH_PARAM, CONFIGURADOR_OAUTH_LAUNCH_VALUE);
    return parsed.toString();
  } catch (error) {
    return url;
  }
}

export function mapOAuthAtalhosToShortcuts(atalhos) {
  return (atalhos || []).map((app, index) => ({
    id: `oauth-app-${app.id}`,
    label: app.nome,
    icon: app.icone || 'fas fa-plug',
    gradient: OAUTH_SHORTCUT_GRADIENTS[index % OAUTH_SHORTCUT_GRADIENTS.length],
    href: isShortcutOnlyType(app.tipo)
      ? app.linkLogin
      : appendConfiguradorOAuthLaunchParam(app.linkLogin),
    external: true,
  }));
}
